const state = {
    hasCertificado: false
};

export default state;
